<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row>
        <v-col>
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Login Out</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
          </v-card>
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>
<script>
  export default {
    data: function() {
      return {
          valid: true,
          error: false,
      };
    },
    computed: {
  
    },
    mounted() {
      this.$store.dispatch('logoutRequest')
      .then(() => {
        this.$store.dispatch('UNSET_OVERLAY');
        this.$router.push('/inicio');
      });
    },
    methods: {

    },
  };
</script>